export default "__VITE_ASSET__Dd8GZBs7__"